module.exports = __webpack_public_path__ + "test1.png?538951a4ade084a33c08ea4a1967f7f8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test1.png
// module id = 82
// module chunks = 0